import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import Home from "@/pages/Home";
import Registry from "@/pages/Registry";
import Profile from "@/pages/Profile";
import { RankingsIndex, RankingDetail, MethodologyPage } from "@/pages/Rankings";
import { Events, EventDetail, News, Article } from "@/pages/Content";
import { GetVerified, ClaimProfile, Intelligence, About, NotFound } from "@/pages/Misc";
import Auth from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Charts from "@/pages/Charts";
import { WorkDetail, GoatMethodology } from "@/pages/Works";
import { EnginePage } from "@/components/wei/EnginePages";

function ScrollTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => { if (hash) document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }); else window.scrollTo(0, 0); }, [pathname, hash]);
  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollTop />
        <div className="App min-h-screen flex flex-col bg-ivory">
          <Header />
          <div className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/registry" element={<Registry />} />
              <Route path="/registry/:slug" element={<Profile />} />
              <Route path="/rankings" element={<RankingsIndex />} />
              <Route path="/rankings/goat-methodology" element={<GoatMethodology />} />
              <Route path="/rankings/engine" element={<EnginePage />} />
              <Route path="/rankings/methodology/:key" element={<MethodologyPage />} />
              <Route path="/rankings/:slug" element={<RankingDetail />} />
              <Route path="/works/:slug" element={<WorkDetail />} />
              <Route path="/charts" element={<Charts />} />
              <Route path="/events" element={<Events />} />
              <Route path="/events/:slug" element={<EventDetail />} />
              <Route path="/news" element={<News />} />
              <Route path="/news/:slug" element={<Article />} />
              <Route path="/get-verified" element={<GetVerified />} />
              <Route path="/claim" element={<ClaimProfile />} />
              <Route path="/intelligence" element={<Intelligence />} />
              <Route path="/about" element={<About />} />
              <Route path="/signin" element={<Auth mode="signin" />} />
              <Route path="/join" element={<Auth mode="join" />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
          <Footer />
        </div>
        <Toaster position="bottom-right" toastOptions={{ style: { background: "#0B0B0B", color: "#fff", border: "1px solid #C99738" } }} />
      </BrowserRouter>
    </AuthProvider>
  );
}
